import { render, staticRenderFns } from "./NumeroForm.vue?vue&type=template&id=f63d11c0&"
import script from "./NumeroForm.vue?vue&type=script&lang=js&"
export * from "./NumeroForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports